import { BaseFetch } from "../main-model";
export default class RegaliaModel extends BaseFetch {
  getRegaliaBy = (data) =>
    this.authFetch({
      url: "regalia/getRegaliaBy",
      method: "POST",
      body: JSON.stringify(data),
    });
  insertRegalia = (data) =>
    this.authFetch({
      url: "regalia/insertRegalia",
      method: "POST",
      body: JSON.stringify(data),
    });
  deleteRegaliaById = (data) =>
    this.authFetch({
      url: "regalia/deleteRegaliaById",
      method: "POST",
      body: JSON.stringify(data),
    });
}
